import _ from 'lodash'
import BigNumber from 'bignumber.js'

const ROUND = 0
const CEIL = 1
const FLOOR = 2

const ADD = 0
const SUBTRACT = 1
const MULTIPLY = 2
const DIVIDE = 3

/**
 * 計算処理.
 * @param {array} nums
 * @param {number} operator 計算方法. ADD or SUBTRACT or MULTIPLY or DIVIDE.
 * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
 */
function calculate (nums, operator) {
  if (!Array.isArray(nums)) {
    return NaN
  }

  let val = BigNumber(0)
  nums.forEach((num, index) => {
    if (index === 0) {
      val = BigNumber(Number(num))
      return
    }
    switch (operator) {
      case ADD:
        val = val.plus(Number(num))
        break
      case SUBTRACT:
        val = val.minus(Number(num))
        break
      case MULTIPLY:
        val = val.times(Number(num))
        break
      case DIVIDE:
        val = val.div(Number(num))
        break
    }
  })
  return val.toNumber()
}

/**
 * 丸め処理.
 * @param {*} num
   * @param {number} [roundMode=ROUND] 丸め処理. ROUND or CEIL or FLOOR.
   * @param {number} [precision=0] 精度.
 */
function round (num, roundMode = ROUND, precision = 0) {
  switch (roundMode) {
    case CEIL:
      return _.ceil(num, precision)
    case FLOOR:
      return _.floor(num, precision)
    case ROUND:
    default:
      return _.round(num, precision)
  }
}

export default {
  ROUND: ROUND,
  CEIL: CEIL,
  FLOOR: FLOOR,
  /**
   * roundMode の方法で precision の桁数で丸めた nums の合計を返却する.
   * roundMode が指定されていない場合、丸め処理は行わない.
   * @param {array} nums
   * @param {number} [roundMode] 丸め処理. ROUND or CEIL or FLOOR.
   * @param {number} [precision]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  add (nums, roundMode, precision) {
    let result = calculate(nums, ADD)
    return roundMode != null ? round(result, roundMode, precision) : result
  },
  /**
   * roundMode の方法で precision の桁数で丸めた nums の差を返却する.
   * roundMode が指定されていない場合、丸め処理は行わない.
   * @param {array} nums
   * @param {number} [roundMode] 丸め処理. ROUND or CEIL or FLOOR.
   * @param {number} [precision]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  subtract (nums, roundMode, precision) {
    let result = calculate(nums, SUBTRACT)
    return roundMode != null ? round(result, roundMode, precision) : result
  },
  /**
   * roundMode の方法で precision の桁数で丸めた nums の積を返却する.
   * roundMode が指定されていない場合、丸め処理は行わない.
   * @param {array} nums
   * @param {number} [roundMode] 丸め処理. ROUND or CEIL or FLOOR.
   * @param {number} [precision]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  multiply (nums, roundMode, precision) {
    let result = calculate(nums, MULTIPLY)
    return roundMode != null ? round(result, roundMode, precision) : result
  },
  /**
   * roundMode の方法で precision の桁数で丸めた nums の商を返却する.
   * roundMode が指定されていない場合、丸め処理は行わない.
   * @param {array} nums
   * @param {number} [roundMode] 丸め処理. ROUND or CEIL or FLOOR.
   * @param {number} [precision]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  divide (nums, roundMode, precision) {
    let result = calculate(nums, DIVIDE)
    return roundMode != null ? round(result, roundMode, precision) : result
  },
  /**
   * num を precision の桁数で切り上げた結果を返却する.
   * @param {number} num
   * @param {number} [precision=0]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  ceil (num, precision = 0) {
    return round(num, this.CEIL, precision)
  },
  /**
   * num を precision の桁数で四捨五入した結果を返却する.
   * @param {number} num
   * @param {number} [precision=0]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  round (num, precision = 0) {
    return round(num, this.ROUND, precision)
  },
  /**
   * num を precision の桁数で切り捨てた結果を返却する.
   * @param {number} num
   * @param {number} [precision=0]
   * @returns {number} 計算結果. 計算に失敗した場合、NaN を返却する.
   */
  floor (num, precision = 0) {
    return round(num, this.FLOOR, precision)
  }
}
